/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { ExcJpmamV1JpmamTaskEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const EXC_JPMAM_V1_JPMAM_TASK_EVENT_ENTITY_NAME = 'exc.jpmam.v1.JpmamTaskEvent';
export const excJpmamV1JpmamTaskEventEntity = new schema.Entity<ExcJpmamV1JpmamTaskEvent>(EXC_JPMAM_V1_JPMAM_TASK_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: ExcJpmamV1JpmamTaskEvent) => `${entity.metadata?.eventId}` });

